<ng-container *ngIf='!inputService.hidden && inputService.formInputDefinition && inputService.control' [formGroup]="inputService.formGroup">
	<label>{{inputService.computedTitle | translate}}</label>
	<br>
	<mat-radio-group [formControlName]='inputService.formControlKey' class='mb-8'>
		<mat-radio-button *ngFor='let selectOption of selectOptions' [value]="selectOption.value">
			<span>{{selectOption.label}}</span>
		</mat-radio-button>
	</mat-radio-group>
</ng-container>